<template>
          <div class="setting-translation">
              <div class="translation preview">
                  <div v-if="!editing">{{translation.text}}</div>
                  <div v-if="!editing" @click="edit"><i class="material-icons">edit</i></div>
              </div>
             <div  class="translation editing">
                  <textarea v-if="editing" rows="4" v-model="translation.text"></textarea>
                  <div class="edit-actions">
                      <i v-if="editing" :disabled="savingTranslation" class="material-icons" @click="save">save</i>
                      <i v-if="editing" class="material-icons" @click="undo">undo</i>
                  </div>
              </div>
              <div class="lang">language : {{$store.langDict[translation.language]}}</div>
          </div>
</template>
<script>
export default {
  name: "TextSettingTranslation",
  props: {
      translation:Object
  },
  data(){
      return{
          editing:false,
          lastTranslation:"",
          savingTranslation:false,
      }
  },
  methods:{
      save(){
          this.savingTranslation = true;
          this.$emit('saveTranslation', this);
      },
      edit(){
          this.editing = true;
          this.lastTranslation = this.translation.text;
      },
      undo(){
          this.translation.text = this.lastTranslation;
          this.editing = false;
      }
  },
  mounted(){
  }
}
</script>
<style scoped>
.setting-translation{
    padding-bottom:10px;
}
.translation{
    font-size:17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.translation i{
    color:rgba(0,0,0,0.8);
}
.lang{
    font-size:12px;
    color:#888;
}
.edit-actions{
    display: flex;
}
.edit-actions i {
    margin:0px 5px;
}
i:hover{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/TextSettingTranslation.vue